// -------------------------------------
// SlickSlider
// -------------------------------------
(function($) {
	var $slider = $(".slider");
	var $gallery = $(".gallery-slider");
	var $testimonials = $(".testimonial-slider");

	// Clickable thumbnails
	$(".gallery-slider-thumbs").on("click", ".slick-slide", function(event) {
		event.preventDefault();
		var goToSingleSlide = $(this).data("slick-index");

		console.log("slick-index: " + goToSingleSlide);

		$gallery.slick("slickGoTo", goToSingleSlide);
	});

	// Slider
	if ($slider.length) {
		$slider.on("init", function(event, slick) {
			$slider.find(".slide").matchHeight();
		});

		// Slick Slider
		$slider.slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			dots: true,
			draggable: true,
			focusOnSelect: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerPadding: 0,
			swipeToSlide: true,
			touchThreshold: 10,
			speed: 200,
			edgeFriction: 0
		});
	}

	// Gallery Slider
	if ($gallery.length) {
		// $gallery.on("init", function(event, slick) {
		// 	$gallery.find(".slide").matchHeight();
		// });

		var $counter = $(".slick-counter");
		var $total = $(".slick-total");

		if ($counter.length && $total.length) {
			$gallery.on("init reInit afterChange", function(
				event,
				slick,
				currentSlide,
				nextSlide
			) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				var i = (currentSlide ? currentSlide : 0) + 1;
				$counter.text(i);
				$total.text(slick.slideCount);
			});
		}

		// Slick Slider
		$gallery.slick({
			initialSlide: 7,
			centerMode: true,
			arrows: true,
			autoplay: false,
			dots: false,
			draggable: true,
			focusOnSelect: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			centerPadding: 30,
			asNavFor: ".gallery-slider-thumbs",
			infinite: false,
			prevArrow: '<button type="button" class="slick-prev">Previous</button>',
			nextArrow: '<button type="button" class="slick-next">Next</button>',
			variableWidth: true,
			variableHeight: true,
			swipeToSlide: true,
			touchThreshold: 10,
			speed: 200,
			cssEase: "linear",
			edgeFriction: 0,

			responsive: [
				{
					breakpoint: 1920,
					settings: {
						variableWidth: false,
						variableHeight: false
					}
				},
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 2,
						arrows: false
					}
				},
				{
					breakpoint: 601,
					settings: {
						slidesToShow: 1,
						arrows: false,
						variableWidth: true,
						variableHeight: true
					}
				}
			]
		});

		// Thumbnails
		var thumbsOptions = {
			initialSlide: 7,
			centerMode: true,
			arrows: false,
			prevArrow: '<button type="button" class="slick-prev">Previous</button>',
			nextArrow: '<button type="button" class="slick-next">Next</button>',
			autoplay: false,
			slidesToShow: 11,
			slidesToScroll: 1,
			centerPadding: 0,
			asNavFor: ".gallery-slider",
			dots: true,
			draggable: false,
			focusOnSelect: true,
			infinite: false,
			swipeToSlide: true,
			touchThreshold: 10,
			speed: 200,
			edgeFriction: 0,
			// customPaging: function(slick, index) {
			// 	return "<a>" + (index + 1) + "</a>";
			// },
			onInit: function() {
				setTimeout(function() {
					$(".slick-slide")
						.slickSetOption("speed", 0)
						.slickGoTo(7)
						.slickSetOption("speed", 200);
				}, 10);
			},
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 13
					}
				},
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 11
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 9
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 7
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 5
					}
				}
			]
		};
		$(".gallery-slider-thumbs").slick(thumbsOptions);
	}

	// Testimonial Slider
	if ($testimonials.length) {
		$testimonials.on("init", function(event, slick) {
			$testimonials.find(".slide").matchHeight();
		});

		// Slick Slider
		$testimonials.slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			dots: true,
			draggable: true,
			focusOnSelect: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			touchThreshold: 10,
			speed: 200,
			edgeFriction: 0
		});
	}
})(jQuery);
